import { ApiRequestFilters } from '../../../types/api-request-filters';

/**
 * Vehicle models filters
 */
export class VehicleModelsFilters extends ApiRequestFilters {
	/**
	 * Make id values
	 */
	public makes?: number[];
}
